<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0"> تاریخچه تغییر وضیعت  دستگاه '{{deviceBehfa_Innner.codeBEHFA}}' </h5>
     <br/>

     <button  (click)="OnSet_Back_DeviceBehfa()"  type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>



      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>وضیعت قبلی</th>
              <th>وضیعت بعدی</th>
              <th>توضیحات</th>
              <th>ثبت کننده</th>
              <th>تاریخ ثبت</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ChangeOperation
            | paginate
                    : {
                        id: 'DataList_ChangeOperation',
                        itemsPerPage: 100,
                        currentPage: page,
                        totalItems: (DataList_ChangeOperation).length
                      }
            " [ngClass]="{'Special': item.special}">
             <td>{{DataList_ChangeOperation.indexOf(item)+1}}</td>

             <td>
              <p *ngIf="item.before_status==1" style="color: #489b39;">فعال</p>
              <p *ngIf="item.before_status==2" style="color: crimson;">غیر فعال</p>
              <p *ngIf="item.before_status==3" style="color: mediumblue;">در حال تعمیر</p>
              <p *ngIf="item.before_status==4" style="color: gold;">در حال کالیبراسیون</p>
              <p *ngIf="item.before_status==5" style="color: rgb(255, 5, 5);">غیر فعال دائم</p>

            </td>

            <td>
              <p *ngIf="item.next_status==1" style="color: #489b39;">فعال</p>
              <p *ngIf="item.next_status==2" style="color: crimson;">غیر فعال</p>
              <p *ngIf="item.next_status==3" style="color: mediumblue;">در حال تعمیر</p>
              <p *ngIf="item.next_status==4" style="color: gold;">در حال کالیبراسیون</p>
              <p *ngIf="item.next_status==5" style="color: rgb(255, 5, 5);">غیر فعال دائم</p>

            </td>

              <td>{{item.dsc}}</td>
              <td>{{item.username}}</td>
              <td>{{item.persianDate}} </td>
            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_ChangeOperation"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

